import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../../lib/apiClient';

type UseRunLogsProps = {
  runUuid: string;
  refetchInterval: number;
  refetchOnMount: boolean;
};

export const useRunLogs = ({
  runUuid,
  refetchInterval,
  refetchOnMount,
}: UseRunLogsProps) =>
  useQuery({
    queryKey: ['hooks', 'run', runUuid, 'logs'] as const,
    queryFn: () => api.request(endpoints.hooks.runLogs(runUuid)),
    refetchOnMount,
    enabled: runUuid.length > 0,
    refetchInterval,
  });
